module.exports = __webpack_public_path__ + "img/22.07945e48.svg";